// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__18M52","modalForm":"UpgradeEpcsModal_modalForm__1aUTX","modalFooter":"UpgradeEpcsModal_modalFooter__1xv8y"};